export const JOB_PENDING_ACTIONS = {
  deleting: 'deleting',
  running: 'running',
  scheduling: 'scheduling',
  updating: 'updating',
  none: 'none',
};
